import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function GraphDesc({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M2.82197 3.22068C2.82197 2.72362 2.41903 2.32068 1.92197 2.32068C1.42492 2.32068 1.02197 2.72362 1.02197 3.22068V20.9287C1.02197 21.4257 1.42492 21.8287 1.92197 21.8287H21.002C21.499 21.8287 21.902 21.4257 21.902 20.9287C21.902 20.4316 21.499 20.0287 21.002 20.0287H2.82197V3.22068ZM18.3301 16.7679H20.8504C21.125 16.8111 21.4159 16.7269 21.6275 16.5153C21.814 16.3287 21.9016 16.0806 21.8901 15.8363V13.2079C21.8901 12.7108 21.4872 12.3079 20.9901 12.3079C20.493 12.3079 20.0901 12.7108 20.0901 13.2079V13.7051L15.6675 9.28248C14.9256 8.54056 13.7274 8.54173 12.9855 9.28167L12.9849 9.28234L10.8439 11.4223L10.8356 11.4305L10.8357 11.4306C10.8137 11.4531 10.7929 11.4589 10.7755 11.4589C10.758 11.4589 10.7365 11.4531 10.7137 11.4298L10.7066 11.4225L10.7066 11.4225L5.63656 6.35155C5.28512 6.00004 4.71527 5.99998 4.36376 6.35142C4.01226 6.70286 4.0122 7.27271 4.36364 7.62421L9.4306 12.6922C10.173 13.4471 11.3771 13.4485 12.1198 12.6919L14.2567 10.5561L14.2568 10.5559C14.297 10.516 14.3567 10.5172 14.3947 10.5553L18.8073 14.9679H18.3301C17.833 14.9679 17.4301 15.3708 17.4301 15.8679C17.4301 16.3649 17.833 16.7679 18.3301 16.7679Z" fill="currentColor" /></Svg>;
}
export default GraphDesc;